export function ComponentButtonBackToTop() {
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 500) {
      $('#button-back-to-top').addClass('active');
    } else {
      $('#button-back-to-top').removeClass('active');
    }
  });

  $('#button-back-to-top').on('click', function(e) {
    e.preventDefault();

    $('html, body').animate({'scrollTop': 0}, 1000);
  });
}
